export { default } from './InfoMaterialsService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/infoMaterials/services/InfoMaterialsService/index.js